import React from "react";

import pkg from "../../lib/pkg";
import { AnalyticsError } from "../../lib/util";
import { IntegrationCategory } from "../../providers/AnalyticsContext";
import useTrackEvent from "../useTrackEvent";
import { ActivityListing, Product } from "./types";
import { mapActivityListingToProduct } from "./util";

const EVENT_NAME = "Product Added to Wishlist";

interface ProductAddedToWishlistProperties extends Product {
  wishlist_id: string;
  wishlist_name: string;
}

export default function useProductsSearched() {
  const trackAdEvent = useTrackEvent(IntegrationCategory.Advertising);

  function track(
    wishlistId: string,
    wishlistName: string,
    activityListing: ActivityListing,
  ) {
    try {
      const product = mapActivityListingToProduct(activityListing);

      const properties: ProductAddedToWishlistProperties = {
        wishlist_id: wishlistId,
        wishlist_name: wishlistName,
        ...product,
      };

      trackAdEvent(EVENT_NAME, properties);
    } catch (error) {
      pkg.onError(new AnalyticsError(EVENT_NAME, error));
    }
  }

  return React.useCallback(track, [trackAdEvent]);
}
